import api from './api'

export default class PaymentService {
  static startPayment() {
    return api.post('/start_payment', {
      // FIXME: Probably needs to be passed as a parameter
      payment_url: window.location.href
    })
  }

  static getExportPrice() {
    return api.get('/get_export_price')
  }

  static applyCoupon(coupon) {
    return api.post('/apply_coupon', { coupon_id: coupon })
  }
}
